import React from 'react';
import ReactCacheBuster from 'react-cache-buster';
import ReactDOM from 'react-dom/client';
import theme from './theme';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import MainStyles from './main.styles';
import Loader from './components/Loader/Loader';
import packageJson from '../package.json';

const root = ReactDOM.createRoot(document.getElementById('root'));
const { version } = packageJson;
root.render(
  <ThemeProvider theme={theme}>
    <React.StrictMode>
      <MainStyles theme={theme} />
      <ReactCacheBuster
        currentVersion={version}
        isEnabled="true" // If false, the library is disabled.
        isVerboseMode={false} // If true, the library writes verbose logs to console.
        loadingComponent={<Loader />} // If not pass, nothing appears at the time of new version check.
        metaFileDirectory="." // If public assets are hosted somewhere other than root on your server.
      >
        <App />
      </ReactCacheBuster>
    </React.StrictMode>
  </ThemeProvider>,
);
